import React from 'react'

import { TopNavigation, TopNavigationItem } from '../TopNavigation'
import { AuthInfo } from '../typedefs'
import TopTaskBar from '../TopNavigation/TopTaskBar'

export type DisplayLanguageType = {
  languageCode: string
  language: string
}
export type SiteHeaderProps = {
  activeMenu?: string
  environment: string
  isOverlayOpen: boolean
  navigation: any
  authInfo: AuthInfo
  handleLogIn: (() => void) | null
  handleLogOut: (() => void) | null
  handleCloseClick: () => void
  handleLogoMenuClick: () => void
  handleMenuClick: (item: TopNavigationItem) => void
  handleSearchClick: () => void
  onAccountSettingsFirstShow: (() => void) | null
  showLangPrefSelector?: boolean
  handlePreferencesClick?: () => void
  handleClosePopupClick: () => void
  languageSlug?: string
  hasLanguageToggle?: boolean
  toggleLanguage: {
    toggleLanguage: (selectedLang: string) => void
    languagesToDisplay: DisplayLanguageType[]
  }
  hamburgerCloseClick: () => void
}

export const TOP_ANCHOR_ID = 'back-to-top'

export const SiteHeader = ({
  activeMenu = '',
  environment,
  isOverlayOpen,
  navigation,
  authInfo,
  handleLogOut,
  handleLogIn,
  onAccountSettingsFirstShow,
  handleCloseClick,
  handleMenuClick,
  handleSearchClick,
  handleClosePopupClick,
  showLangPrefSelector = false,
  languageSlug = 'en',
  handlePreferencesClick = () => {},
  hasLanguageToggle,
  toggleLanguage,
  hamburgerCloseClick,
  handleLogoMenuClick
}: SiteHeaderProps) => {
  return (
    <>
      <TopTaskBar
        handleClosePopupClick={handleClosePopupClick}
        authInfo={authInfo}
        onAccountSettingsFirstShow={onAccountSettingsFirstShow}
        handleLogOut={handleLogOut}
        handleLogIn={handleLogIn}
      />
      <nav className="frw-header" id={TOP_ANCHOR_ID}>
        <div className="frw-wrapper--1 frw-content">
          <TopNavigation
            {...navigation}
            environment={environment}
            handleCloseClick={handleCloseClick}
            handleSearchClick={handleSearchClick}
            handleMenuClick={handleMenuClick}
            handleClosePopupClick={handleClosePopupClick}
            isOverlayOpen={isOverlayOpen}
            activeMenu={activeMenu}
            showLangPrefSelector={showLangPrefSelector}
            handlePreferencesClick={handlePreferencesClick}
            languageSlug={languageSlug}
            hasLanguageToggle={hasLanguageToggle}
            toggleLanguage={toggleLanguage.toggleLanguage}
            languagesToDisplay={toggleLanguage.languagesToDisplay}
            handleLogoMenuClick={handleLogoMenuClick}
            hamburgerCloseClick={hamburgerCloseClick}
          />
        </div>
      </nav>
    </>
  )
}
export default SiteHeader
